const foreskin = [
        
    { 
    label:"Involving:",
    controlType:"radio button",
    options:["Foreskin", "Glans", "Foreskin and glans"]
    },

    { 
    label:"Description",
    controlType:"text area",
    options:[]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]

export default foreskin